function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import { ModalReact } from 'common/components/modal';
import { InputReact } from 'common/components/input';
import { InputLabelReact } from 'common/components/input/label';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { ValidationStatus } from 'common/components/input/types';
import { useTranslation } from 'common/i18n/hooks';
import { SectionItem } from 'common/components/items-menu/types';
import type { AggregationSelector, ModalResolvedValue } from './constants';
import styles from './custom-percentile-modal.module.styl';
export const CustomPercentileModal = (props: InstanceProps<ModalResolvedValue> & ModalResolvedValue) => {
  const {
    t
  } = useTranslation();
  const [percentileValue, setPercentileValue] = useState("");
  const [error, setError] = useState("");
  const validatePercentileValue = (value: string): string => {
    if (!value.trim()) {
      return "";
    }
    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) {
      return t("query-builder.count-menu.custom-percentile-modal.error-invalid-number");
    }
    if (numericValue <= 0 || numericValue >= 100) {
      return t("query-builder.count-menu.custom-percentile-modal.error-out-of-range");
    }
    return "";
  };
  const handleValueChange = (value: string) => {
    setPercentileValue(value);
    setError(validatePercentileValue(value));
  };
  const handleConfirm = () => {
    if (error || !percentileValue.trim()) {
      return;
    }
    const modifiedAggregation: SectionItem<AggregationSelector> = _objectSpread(_objectSpread({}, props.aggregation), {}, {
      value: _objectSpread(_objectSpread({}, props.aggregation.value), {}, {
        percentile: parseFloat(percentileValue)
      }) as AggregationSelector
    });
    props.onResolve({
      aggregation: modifiedAggregation,
      subSelectionIndex: props.subSelectionIndex
    });

    // Reset state
    setPercentileValue("");
    setError("");
  };
  const handleCancel = () => {
    setPercentileValue("");
    setError("");
    props.onResolve(null);
  };
  const handleClose = (ev: any) => {
    if (ev.detail.state === "closed") {
      handleCancel();
    }
  };
  return <ModalReact open modalTitle={t("query-builder.count-menu.custom-percentile-modal.title")} modalDescription='Modal for entering custom percentile value' growToContent onChange={handleClose} data-sentry-element="ModalReact" data-sentry-component="CustomPercentileModal" data-sentry-source-file="custom-percentile-modal.tsx">
      <div className={styles.content}>
        <InputLabelReact data-sentry-element="InputLabelReact" data-sentry-source-file="custom-percentile-modal.tsx">{t("query-builder.count-menu.custom-percentile-modal.label")}</InputLabelReact>
        <InputReact type='number' value={percentileValue} onInput={ev => handleValueChange((ev.target as HTMLInputElement).value)} placeholder={t("query-builder.count-menu.custom-percentile-modal.placeholder")} validationStatus={error ? ValidationStatus.Invalid : ValidationStatus.Default} errorMessage={error} data-sentry-element="InputReact" data-sentry-source-file="custom-percentile-modal.tsx" />
        <div className={styles.actions}>
          <ButtonReact theme={ButtonTheme.Secondary} onClick={handleCancel} data-sentry-element="ButtonReact" data-sentry-source-file="custom-percentile-modal.tsx">
            {t("common.cancel")}
          </ButtonReact>
          <ButtonReact theme={ButtonTheme.Primary} onClick={handleConfirm} disabled={!percentileValue.trim() || !!error} data-sentry-element="ButtonReact" data-sentry-source-file="custom-percentile-modal.tsx">
            {t("common.confirm")}
          </ButtonReact>
        </div>
      </div>
    </ModalReact>;
};
export const openCustomPercentileModal = create(CustomPercentileModal);